import React from 'react';
import { BpmTable } from './BpmTable';
import { getRatioAsPercentage } from './utils';

export const WinLossDecisionLocationsTable = ({ locationToWinLoss }) => {
    if (!locationToWinLoss) {
        return null;
    }
    const rowsAndCols = getTableRowsAndCols(locationToWinLoss);
    return (
        <BpmTable
            cols={rowsAndCols.cols}
            data={rowsAndCols.rows}
        />
    );
}

function getTableRowsAndCols(locationToWinLoss) {
    const result = {
        rows: [], cols: [
            {
                title: 'Country', field: 'country'
            },
            {
                title: 'Region', field: 'region'
            },
            {
                title: 'City', field: 'city'
            },
            {
                title: 'Decisions', field: 'decisions'
            },
            {
                title: 'Wins', field: 'wins'
            },
            {
                title: 'Win %', field: 'winPercentage'
            }]
    };

    for (const value of locationToWinLoss.values()) {
        const row = {
            country: value.country,
            region: value.region,
            city: value.city,
            decisions: value.wins + value.losses,
            wins: value.wins,
            winPercentage: getRatioAsPercentage(value.wins, value.wins + value.losses)
        }
        result.rows.push(row);
    }

    return result;
}